import { jsx as _jsx } from "react/jsx-runtime";
import { _values, dbObjectToId, filterDuplicates, flatArray } from '@nu-art/ts-common';
import './Renderer_AlertWarningForDP.scss';
import { ModuleFE_Value } from '@app/hcs-frontend';
import { ICONS } from '@app/styles';
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_DiseaseProfile, ModuleFE_DiseaseValue, ModuleFE_MultiVar } from '../../../_entity.js';
export class Renderer_AlertWarningForDP extends ComponentSync {
    __onDiseaseProfilesShowErrorAlertsUpdated() {
        this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        this.logDebug('Instance Check');
        if (!ModuleFE_DiseaseProfile.showDiseaseProfileErrorAlerts.get()) {
            state.errorCount = 0;
            return state;
        }
        if (!this.props.relatedMultiVars) {
            state.errorCount = 0;
            return state;
        }
        const multiVarsIds = (typeof nextProps.relatedMultiVars === 'function'
            ? ModuleFE_MultiVar.cache.filter(nextProps.relatedMultiVars)
            : nextProps.relatedMultiVars)?.map(dbObjectToId) || [];
        const valueIds = filterDuplicates(flatArray(ModuleFE_DiseaseValue.cache.filter(dv => multiVarsIds?.includes(dv.multiVarId)).map(dv => _values(dv.values))));
        const values = ModuleFE_Value.cache.filter(v => valueIds.includes(v._id));
        state.errorCount = valueIds.length - values.length;
        return state;
    }
    renderAlertErrorIcon = () => {
        if (!this.state.errorCount)
            return '';
        return _jsx(ICONS.attention.component, { className: 'warning-icon' });
    };
    render() {
        return this.renderAlertErrorIcon();
    }
}
//# sourceMappingURL=Renderer_AlertWarningForDP.js.map